module.exports = {
  purge: false,
  theme: {
    extend: {},

    transitionDuration: {
      default: '0ms',
      70: '70ms',
      140: '140ms',
      210: '210ms',
      280: '280ms',
    },
    transitionTimingFunction: {
      default: 'cubic-bezier(0.2, 0, 0.38, 0.9)',
      expressive: 'cubic-bezier(0.4, 0.14, 0.3, 1)',
      linear: 'linear',
    },
    fontFamily: {
      display: ['Quicksand', 'sans-serif'],
      body: ['Roboto', 'sans-serif'],
    },
    colors: {
      primary: {
        default: '#002de6',
        '10': '#e6e6ff',
        '20': '#b3b3ff',
        '30': '#8080ff',
        '40': '#4d4dff',
        '50': '#1a1aff',
        '60': '#0000e6',
        '70': '#0000b3',
        '80': '#000080',
        '90': '#00004c',
        '100': '#000019',
      },

      error: '#ff0000',
      success: '#6bb986',

      gray: {
        '10': '#f0f3f8',
        '20': '#b7b9bd',
        '30': '#5f6062',
        '40': '#0d182c',
      },
      black: {
        default: '#000',
        5: 'rgba(0,0,0,.05)',
        10: 'rgba(0,0,0,.1)',
        50: 'rgba(0,0,0,.5)',
      },
      white: {
        default: '#fff',
        20: 'rgba(255,255,255,.2)',
        70: 'rgba(255,255,255,.7)',
      },
      current: 'currentColor',
      transparent: 'transparent',
    },
  },
}
